import React from 'react';
import { MultiBulkActionButton } from './MultiBulkActionButton';
import { MultiBulkActionPopover } from './MultiBulkActionPopover';
import { MultiBulkActionSubItemPrivate } from './MultiBulkActionProps';
import { MultiBulkActionToolbarState } from '../MultiBulkActionToolbar';
import { FiltersMap } from '@wix/bex-core';

export function MultiBulkActionControl<T, F extends FiltersMap>(props: {
  actionItem: MultiBulkActionSubItemPrivate;
  state: MultiBulkActionToolbarState<T, F>;
}) {
  const { actionItem, state } = props;
  const { subItems } = actionItem;
  return subItems ? (
    <MultiBulkActionPopover state={state} actionItem={actionItem} />
  ) : (
    <MultiBulkActionButton state={state} actionItem={actionItem} />
  );
}
